import React from 'react'
import type { RangeKey } from '@dataTypes/dashboard.types'
import DashboardSchedulingPerformancePanel from '@components/pages/Dashboard/SchedulingPerformancePanel/DashboardSchedulingPerformancePanel.component'
import type { SchedulingPerformanceOverviewResult } from '@services/api/dashboard/scheduling-performance.api'

type SchedulingPerformanceCardProps = {
  titleHref: string
  range: RangeKey
  loading: boolean
  schedulingPerformanceOverview: SchedulingPerformanceOverviewResult | null
}

export function SchedulingPerformanceCard({
  titleHref,
  range,
  loading,
  schedulingPerformanceOverview,
}: SchedulingPerformanceCardProps): React.ReactElement {
  return (
    <DashboardSchedulingPerformancePanel
      title="Scheduling performance"
      titleHref={titleHref}
      className="dashboard-operations-scheduling-card"
      firstColumnLabel="Schedule overview"
      range={range}
      loading={loading}
      schedulingPerformanceOverview={schedulingPerformanceOverview}
    />
  )
}
